import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

/**
 * Store-модуль для карточки заявки
 */
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
